import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid grid-wrrapper" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexGrid',
  setup(__props) {

const gridOptions = defineAsyncComponent(() => import("@/components/theme/uikits/grid/gridOptions.vue"))
const gridColumm = defineAsyncComponent(() => import("@/components/theme/uikits/grid/gridColumm.vue"))
const gridAlignment = defineAsyncComponent(() => import("@/components/theme/uikits/grid/gridAlignment.vue"))
const gridSection = defineAsyncComponent(() => import("@/components/theme/uikits/grid/gridSection.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      title: "Grid"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(gridOptions)),
        _createVNode(_unref(gridColumm)),
        _createVNode(_unref(gridAlignment)),
        _createVNode(_unref(gridSection))
      ])
    ])
  ], 64))
}
}

})